import { getMeta, onDomReady } from './helpers';

// Set webpack public asset url
window.__webpack_public_path__ = getMeta('theme-url');

import { Application } from '@hotwired/stimulus';
import AxiosFormController from './controllers/axios-form-controller';
import BlockAsyncController from './controllers/block-async-controller';
import SwiperController from './controllers/swiper-controller';
import AccordionController from './controllers/accordion-controller';
import ShowMoreController from './controllers/show-more-controller';
import MapController from './controllers/map-controller';
import FormTriggerController from './controllers/form-trigger-controller';
import TimetableController from './controllers/timetable-controller';
import TabController from './controllers/tab-controller';
import DatePickerController from './controllers/date-picker-controller';
import TippyController from './controllers/tippy-controller';
import CheckoutController from './controllers/checkout-controller';
import ModalController from './controllers/modal-controller';
import PasswordToggleController from './controllers/password-toggle-controller';
import VacationController from './controllers/vacation-controller';
import CookieBarController from './controllers/cookie-bar-controller';
import FileController from './file-controller';

require('./navigation');
require('fslightbox');
require('./phone-input');

const application = Application.start();

window.Stimulus = application;

application.register('block-async', BlockAsyncController);
application.register('axios-form', AxiosFormController);
application.register('swiper', SwiperController);
application.register('accordion', AccordionController);
application.register('show-more', ShowMoreController);
application.register('map', MapController);
application.register('form-trigger', FormTriggerController);
application.register('timetable', TimetableController);
application.register('tab', TabController);
application.register('date-picker', DatePickerController);
application.register('tippy', TippyController);
application.register('checkout', CheckoutController);
application.register('modal', ModalController);
application.register('password-toggle', PasswordToggleController);
application.register('vacation', VacationController);
application.register('cookie-bar', CookieBarController);
application.register('file', FileController);

onDomReady(() => {
   const membershipsTables = document.querySelectorAll('.c-memberships__table');

   if (membershipsTables) {
      membershipsTables.forEach((table) => {
         const cells = table.querySelectorAll('tr th, tr td');
         cells.forEach((cell) => {
            cell.addEventListener('mouseenter', () => {
               const attr = cell.dataset.attr;
               const colCells = table.querySelectorAll(`tr th[data-attr="${attr}"], tr td[data-attr="${attr}"]`);
               colCells.forEach((colCell) => {
                  colCell.classList.add('highlighted');
               });
            });

            cell.addEventListener('mouseleave', () => {
               const attr = cell.dataset.attr;
               const colCells = table.querySelectorAll(`tr th[data-attr="${attr}"], tr td[data-attr="${attr}"]`);
               colCells.forEach((colCell) => {
                  colCell.classList.remove('highlighted');
               });
            });
         });
      });
   }
});

